exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wordpress-card__instructions{font-size:.875em;line-height:1.785em;font-weight:bold}.wordpress-card__list{list-style-type:none;padding:0 1em;counter-reset:counter}.wordpress-card__list-item{opacity:.75;counter-increment:counter}.wordpress-card__list-item::before{content:\"Step \" counter(counter) \": \";margin-left:-1em;padding-right:.1em}.wordpress-card__instructions-text{margin-top:2em;opacity:.75;font-weight:bold}", ""]);

// exports
